import { render, staticRenderFns } from "./cprs-header.vue?vue&type=template&id=71a2667f"
import script from "./cprs-header.ts?vue&type=script&lang=ts&external"
export * from "./cprs-header.ts?vue&type=script&lang=ts&external"
import style0 from "./cprs-header.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports